var map = {
	"./activity.svg": 977290,
	"./add-circle.svg": 599582,
	"./archive.svg": 906840,
	"./arrow-down.svg": 646979,
	"./arrow-right-2.svg": 313871,
	"./bag-2.svg": 736670,
	"./book-1.svg": 162232,
	"./book.svg": 397986,
	"./bookmark.svg": 119722,
	"./box-1.svg": 574573,
	"./box.svg": 326029,
	"./brush-2.svg": 745136,
	"./calendar-tick.svg": 954632,
	"./calendar.svg": 126150,
	"./call.svg": 676278,
	"./camera.svg": 644416,
	"./card.svg": 332604,
	"./chart-1.svg": 475967,
	"./chart-2.svg": 512693,
	"./clipboard-text.svg": 621201,
	"./clipboard-tick.svg": 164129,
	"./clock.svg": 854199,
	"./close-circle.svg": 440196,
	"./code.svg": 506377,
	"./coin.svg": 12383,
	"./color-swatch.svg": 606583,
	"./copy.svg": 114359,
	"./cup.svg": 6412,
	"./custom-active.svg": 3735,
	"./custom-alarm.svg": 634456,
	"./custom-archive.svg": 72540,
	"./custom-bell-pin.svg": 694451,
	"./custom-check.svg": 315467,
	"./custom-collapse.svg": 513263,
	"./custom-critical.svg": 415408,
	"./custom-cursor-click.svg": 381876,
	"./custom-distribute-spacing-vertical.svg": 397918,
	"./custom-done-all.svg": 350374,
	"./custom-download.svg": 807951,
	"./custom-expand.svg": 740031,
	"./custom-feather.svg": 8616,
	"./custom-file-search.svg": 715166,
	"./custom-home-stars.svg": 177159,
	"./custom-info.svg": 242030,
	"./custom-more.svg": 355198,
	"./custom-nesting.svg": 371418,
	"./custom-notification-pin.svg": 447464,
	"./custom-palette.svg": 908691,
	"./custom-pause.svg": 159004,
	"./custom-pin.svg": 355507,
	"./custom-public-page.svg": 683378,
	"./custom-puzzle-piece.svg": 698117,
	"./custom-question.svg": 613280,
	"./custom-rocket.svg": 631762,
	"./custom-save.svg": 238353,
	"./custom-sparkles.svg": 491159,
	"./custom-stars.svg": 166930,
	"./custom-subtasks.svg": 681735,
	"./custom-upload.svg": 846192,
	"./custom-video-file.svg": 109041,
	"./custom-widget-alt.svg": 768549,
	"./danger.svg": 900367,
	"./diamonds.svg": 755533,
	"./direct-inbox.svg": 600087,
	"./direct-normal.svg": 68308,
	"./discover.svg": 432730,
	"./dislike.svg": 213148,
	"./document-1.svg": 197778,
	"./document-text.svg": 507304,
	"./edit-2.svg": 686816,
	"./edit.svg": 544928,
	"./element-3.svg": 519379,
	"./element-plus.svg": 202791,
	"./export-3.svg": 236216,
	"./export.svg": 816164,
	"./eye-slash.svg": 758365,
	"./eye.svg": 326932,
	"./filter.svg": 694333,
	"./flag.svg": 625171,
	"./flash-circle.svg": 986053,
	"./flash.svg": 248300,
	"./folder-2.svg": 724435,
	"./folder.svg": 888529,
	"./frame.svg": 696214,
	"./gallery.svg": 881384,
	"./gift.svg": 232944,
	"./global.svg": 97053,
	"./gps.svg": 34559,
	"./graph.svg": 407673,
	"./grid-8.svg": 332021,
	"./headphone.svg": 299234,
	"./heart.svg": 150347,
	"./home-1.svg": 5542,
	"./lamp-on.svg": 336041,
	"./layer.svg": 709335,
	"./lifebuoy.svg": 230844,
	"./like.svg": 78963,
	"./location.svg": 817997,
	"./lock.svg": 179153,
	"./login-1.svg": 203193,
	"./logout.svg": 125885,
	"./magicpen.svg": 582455,
	"./map-1.svg": 324710,
	"./medal-star.svg": 763409,
	"./message-text.svg": 138672,
	"./message.svg": 333045,
	"./messages-2.svg": 563378,
	"./messages-3.svg": 333506,
	"./microphone-2.svg": 356033,
	"./money.svg": 629260,
	"./moon.svg": 205257,
	"./music.svg": 383533,
	"./notification.svg": 596716,
	"./path-2.svg": 580940,
	"./pause.svg": 942074,
	"./people.svg": 804390,
	"./play-circle.svg": 397543,
	"./play.svg": 438286,
	"./profile-2user.svg": 78749,
	"./profile-circle.svg": 946510,
	"./receipt-item.svg": 778773,
	"./record-circle.svg": 349324,
	"./scan-barcode.svg": 953303,
	"./search-normal-1.svg": 216272,
	"./send-2.svg": 671184,
	"./setting-2.svg": 965277,
	"./share.svg": 768927,
	"./shield.svg": 145970,
	"./shop.svg": 955521,
	"./sms.svg": 253207,
	"./star-1.svg": 659038,
	"./star.svg": 803184,
	"./story.svg": 200099,
	"./sun-1.svg": 302453,
	"./tag.svg": 860506,
	"./teacher.svg": 747357,
	"./tick-circle.svg": 298847,
	"./tick-square.svg": 368010,
	"./ticket-star.svg": 702527,
	"./timer-1.svg": 350995,
	"./trash.svg": 8051,
	"./unlock.svg": 746972,
	"./user-square.svg": 291344,
	"./user.svg": 981916,
	"./verify.svg": 346810,
	"./video-square.svg": 608630,
	"./volume-high.svg": 769687,
	"./wallet.svg": 588879,
	"core/ui/iconsax/bold/activity.svg": 977290,
	"core/ui/iconsax/bold/add-circle.svg": 599582,
	"core/ui/iconsax/bold/archive.svg": 906840,
	"core/ui/iconsax/bold/arrow-down.svg": 646979,
	"core/ui/iconsax/bold/arrow-right-2.svg": 313871,
	"core/ui/iconsax/bold/bag-2.svg": 736670,
	"core/ui/iconsax/bold/book-1.svg": 162232,
	"core/ui/iconsax/bold/book.svg": 397986,
	"core/ui/iconsax/bold/bookmark.svg": 119722,
	"core/ui/iconsax/bold/box-1.svg": 574573,
	"core/ui/iconsax/bold/box.svg": 326029,
	"core/ui/iconsax/bold/brush-2.svg": 745136,
	"core/ui/iconsax/bold/calendar-tick.svg": 954632,
	"core/ui/iconsax/bold/calendar.svg": 126150,
	"core/ui/iconsax/bold/call.svg": 676278,
	"core/ui/iconsax/bold/camera.svg": 644416,
	"core/ui/iconsax/bold/card.svg": 332604,
	"core/ui/iconsax/bold/chart-1.svg": 475967,
	"core/ui/iconsax/bold/chart-2.svg": 512693,
	"core/ui/iconsax/bold/clipboard-text.svg": 621201,
	"core/ui/iconsax/bold/clipboard-tick.svg": 164129,
	"core/ui/iconsax/bold/clock.svg": 854199,
	"core/ui/iconsax/bold/close-circle.svg": 440196,
	"core/ui/iconsax/bold/code.svg": 506377,
	"core/ui/iconsax/bold/coin.svg": 12383,
	"core/ui/iconsax/bold/color-swatch.svg": 606583,
	"core/ui/iconsax/bold/copy.svg": 114359,
	"core/ui/iconsax/bold/cup.svg": 6412,
	"core/ui/iconsax/bold/custom-active.svg": 3735,
	"core/ui/iconsax/bold/custom-alarm.svg": 634456,
	"core/ui/iconsax/bold/custom-archive.svg": 72540,
	"core/ui/iconsax/bold/custom-bell-pin.svg": 694451,
	"core/ui/iconsax/bold/custom-check.svg": 315467,
	"core/ui/iconsax/bold/custom-collapse.svg": 513263,
	"core/ui/iconsax/bold/custom-critical.svg": 415408,
	"core/ui/iconsax/bold/custom-cursor-click.svg": 381876,
	"core/ui/iconsax/bold/custom-distribute-spacing-vertical.svg": 397918,
	"core/ui/iconsax/bold/custom-done-all.svg": 350374,
	"core/ui/iconsax/bold/custom-download.svg": 807951,
	"core/ui/iconsax/bold/custom-expand.svg": 740031,
	"core/ui/iconsax/bold/custom-feather.svg": 8616,
	"core/ui/iconsax/bold/custom-file-search.svg": 715166,
	"core/ui/iconsax/bold/custom-home-stars.svg": 177159,
	"core/ui/iconsax/bold/custom-info.svg": 242030,
	"core/ui/iconsax/bold/custom-more.svg": 355198,
	"core/ui/iconsax/bold/custom-nesting.svg": 371418,
	"core/ui/iconsax/bold/custom-notification-pin.svg": 447464,
	"core/ui/iconsax/bold/custom-palette.svg": 908691,
	"core/ui/iconsax/bold/custom-pause.svg": 159004,
	"core/ui/iconsax/bold/custom-pin.svg": 355507,
	"core/ui/iconsax/bold/custom-public-page.svg": 683378,
	"core/ui/iconsax/bold/custom-puzzle-piece.svg": 698117,
	"core/ui/iconsax/bold/custom-question.svg": 613280,
	"core/ui/iconsax/bold/custom-rocket.svg": 631762,
	"core/ui/iconsax/bold/custom-save.svg": 238353,
	"core/ui/iconsax/bold/custom-sparkles.svg": 491159,
	"core/ui/iconsax/bold/custom-stars.svg": 166930,
	"core/ui/iconsax/bold/custom-subtasks.svg": 681735,
	"core/ui/iconsax/bold/custom-upload.svg": 846192,
	"core/ui/iconsax/bold/custom-video-file.svg": 109041,
	"core/ui/iconsax/bold/custom-widget-alt.svg": 768549,
	"core/ui/iconsax/bold/danger.svg": 900367,
	"core/ui/iconsax/bold/diamonds.svg": 755533,
	"core/ui/iconsax/bold/direct-inbox.svg": 600087,
	"core/ui/iconsax/bold/direct-normal.svg": 68308,
	"core/ui/iconsax/bold/discover.svg": 432730,
	"core/ui/iconsax/bold/dislike.svg": 213148,
	"core/ui/iconsax/bold/document-1.svg": 197778,
	"core/ui/iconsax/bold/document-text.svg": 507304,
	"core/ui/iconsax/bold/edit-2.svg": 686816,
	"core/ui/iconsax/bold/edit.svg": 544928,
	"core/ui/iconsax/bold/element-3.svg": 519379,
	"core/ui/iconsax/bold/element-plus.svg": 202791,
	"core/ui/iconsax/bold/export-3.svg": 236216,
	"core/ui/iconsax/bold/export.svg": 816164,
	"core/ui/iconsax/bold/eye-slash.svg": 758365,
	"core/ui/iconsax/bold/eye.svg": 326932,
	"core/ui/iconsax/bold/filter.svg": 694333,
	"core/ui/iconsax/bold/flag.svg": 625171,
	"core/ui/iconsax/bold/flash-circle.svg": 986053,
	"core/ui/iconsax/bold/flash.svg": 248300,
	"core/ui/iconsax/bold/folder-2.svg": 724435,
	"core/ui/iconsax/bold/folder.svg": 888529,
	"core/ui/iconsax/bold/frame.svg": 696214,
	"core/ui/iconsax/bold/gallery.svg": 881384,
	"core/ui/iconsax/bold/gift.svg": 232944,
	"core/ui/iconsax/bold/global.svg": 97053,
	"core/ui/iconsax/bold/gps.svg": 34559,
	"core/ui/iconsax/bold/graph.svg": 407673,
	"core/ui/iconsax/bold/grid-8.svg": 332021,
	"core/ui/iconsax/bold/headphone.svg": 299234,
	"core/ui/iconsax/bold/heart.svg": 150347,
	"core/ui/iconsax/bold/home-1.svg": 5542,
	"core/ui/iconsax/bold/lamp-on.svg": 336041,
	"core/ui/iconsax/bold/layer.svg": 709335,
	"core/ui/iconsax/bold/lifebuoy.svg": 230844,
	"core/ui/iconsax/bold/like.svg": 78963,
	"core/ui/iconsax/bold/location.svg": 817997,
	"core/ui/iconsax/bold/lock.svg": 179153,
	"core/ui/iconsax/bold/login-1.svg": 203193,
	"core/ui/iconsax/bold/logout.svg": 125885,
	"core/ui/iconsax/bold/magicpen.svg": 582455,
	"core/ui/iconsax/bold/map-1.svg": 324710,
	"core/ui/iconsax/bold/medal-star.svg": 763409,
	"core/ui/iconsax/bold/message-text.svg": 138672,
	"core/ui/iconsax/bold/message.svg": 333045,
	"core/ui/iconsax/bold/messages-2.svg": 563378,
	"core/ui/iconsax/bold/messages-3.svg": 333506,
	"core/ui/iconsax/bold/microphone-2.svg": 356033,
	"core/ui/iconsax/bold/money.svg": 629260,
	"core/ui/iconsax/bold/moon.svg": 205257,
	"core/ui/iconsax/bold/music.svg": 383533,
	"core/ui/iconsax/bold/notification.svg": 596716,
	"core/ui/iconsax/bold/path-2.svg": 580940,
	"core/ui/iconsax/bold/pause.svg": 942074,
	"core/ui/iconsax/bold/people.svg": 804390,
	"core/ui/iconsax/bold/play-circle.svg": 397543,
	"core/ui/iconsax/bold/play.svg": 438286,
	"core/ui/iconsax/bold/profile-2user.svg": 78749,
	"core/ui/iconsax/bold/profile-circle.svg": 946510,
	"core/ui/iconsax/bold/receipt-item.svg": 778773,
	"core/ui/iconsax/bold/record-circle.svg": 349324,
	"core/ui/iconsax/bold/scan-barcode.svg": 953303,
	"core/ui/iconsax/bold/search-normal-1.svg": 216272,
	"core/ui/iconsax/bold/send-2.svg": 671184,
	"core/ui/iconsax/bold/setting-2.svg": 965277,
	"core/ui/iconsax/bold/share.svg": 768927,
	"core/ui/iconsax/bold/shield.svg": 145970,
	"core/ui/iconsax/bold/shop.svg": 955521,
	"core/ui/iconsax/bold/sms.svg": 253207,
	"core/ui/iconsax/bold/star-1.svg": 659038,
	"core/ui/iconsax/bold/star.svg": 803184,
	"core/ui/iconsax/bold/story.svg": 200099,
	"core/ui/iconsax/bold/sun-1.svg": 302453,
	"core/ui/iconsax/bold/tag.svg": 860506,
	"core/ui/iconsax/bold/teacher.svg": 747357,
	"core/ui/iconsax/bold/tick-circle.svg": 298847,
	"core/ui/iconsax/bold/tick-square.svg": 368010,
	"core/ui/iconsax/bold/ticket-star.svg": 702527,
	"core/ui/iconsax/bold/timer-1.svg": 350995,
	"core/ui/iconsax/bold/trash.svg": 8051,
	"core/ui/iconsax/bold/unlock.svg": 746972,
	"core/ui/iconsax/bold/user-square.svg": 291344,
	"core/ui/iconsax/bold/user.svg": 981916,
	"core/ui/iconsax/bold/verify.svg": 346810,
	"core/ui/iconsax/bold/video-square.svg": 608630,
	"core/ui/iconsax/bold/volume-high.svg": 769687,
	"core/ui/iconsax/bold/wallet.svg": 588879
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 213315;